import { useState } from 'react';
import { getContainer } from '@framework/di/getContainer';
import { getErrorMessage } from '@framework/message/Mapper/getMessage';
import { AlertManager } from '@dealroadshow/uikit-alert';
import CountryRepository from '@dm-portal/country/CountryRepository';

export interface ICountry {
  code: string,
  id: string,
  marketRegionId: string,
  name: string,
}

const useCountries = (initial?: [ICountry?]) => {
  const container = getContainer();
  const [isFetching, setIsFetching] = useState(false);
  const [collection, setCollection] = useState<[ICountry?]>(initial || []);

  async function getCountriesList() {
    setIsFetching(true);

    try {
      const countryRepository = container.get<CountryRepository>(CountryRepository);
      const response = await countryRepository.getCountries();
      setCollection(response);
    } catch (error) {
      AlertManager.error(getErrorMessage(error));
    } finally {
      setIsFetching(false);
    }
  }

  return {
    isFetching,
    collection,
    getCountriesList,
  };
};

export default useCountries;
